

/**
 * Bankers rounding (round half to even). Matches backend VNumber.CalculateVSize.
 */
function roundHalfToEven(n: number): number {
    const floor = Math.floor(n);
    const frac = n - floor;
    const isHalf = frac >= 0.4999999 && frac <= 0.5000001;
    if (isHalf) {
        return floor % 2 === 0 ? floor : floor + 1;
    }
    return Math.round(n);
}

/**
 * Packing formula: (L×W×H… in cm) / 1000, bankers round, min 1. Matches backend VNumber.CalculateVSize.
 */
export function computeV(numbers: number[]): string {
    const product = numbers.reduce((acc, current) => acc * current, 1);
    const volume = product * 0.001;
    const rounded = roundHalfToEven(volume);
    const v = Math.max(1, rounded);

    if (isNaN(v)) return "";
    return "V" + v;
}